export function toggleUomPrice(price) {
  const noPricingElements = document.querySelectorAll('.no-pricing')
  const hasPricingElements = document.querySelectorAll('.has-pricing')
  
  if (price === 0) {
    showElements(noPricingElements)
    hideElements(hasPricingElements)
  } else {
    hideElements(noPricingElements)
    showElements(hasPricingElements)
  }
}

function showElements(elements) {
  elements.forEach(el => el.classList.remove('hide'))
}

function hideElements(elements) {
  elements.forEach(el => el.classList.add('hide'))
}
